export function formatGroupName(name: string) {
    return name.replace(/([-_])/g, ' ')
}
